import AssetCard from './AssetCard.container';

export default AssetCard;
